import { PropsWithChildren } from 'react';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { createAppKit } from '@reown/appkit/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { WagmiProvider } from 'wagmi';
import { bsc } from 'wagmi/chains';
import { queryClient } from '@/shared/providers/QueryProvider';



// 1. Get projectId from https://cloud.reown.com
const projectId = import.meta.env.VITE_APP_KIT_PROJECT_ID as string;

// 2. Create a metadata object - optional
const metadata = {
    name: 'TradeEnrich',
    description: 'TradeEnrich: Save smarter, Earn monthly, Build wealth',
    url: import.meta.env.VITE_HOST,
    icons: ['https://drive.usercontent.google.com/download?id=1auRUAWJtk-lSsQUOAlv1iYRYjwo0CzWk&export=view&authuser=0'],
};

// 3. Set the networks
const networks = [bsc];





// 4. Create Wagmi Adapter
const wagmiAdapter = new WagmiAdapter({
    networks,
    projectId,
    ssr: true,
});

// 5. Create modal
createAppKit({
    adapters: [wagmiAdapter],
    networks: [bsc],
    defaultNetwork: bsc,
    projectId,
    metadata,
    features: {
        analytics: true, // Optional - defaults to your Cloud configuration
    },
});

export function AppKitProvider({ children }: PropsWithChildren) {
    return (
        <WagmiProvider config={wagmiAdapter.wagmiConfig}>
            <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
        </WagmiProvider>
    );
}
